import { initializeApp } from "firebase/app";
import {
  getFirestore,
  collection,
  addDoc,
  doc,
  updateDoc,
  deleteDoc,
  onSnapshot,
} from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getFunctions } from "firebase/functions";
import { getStorage, ref } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBFSlIwipOleDeXct0KLSg46TekOINQKTE",
  authDomain: "emerals-b6b8a.firebaseapp.com",
  projectId: "emerals-b6b8a",
  storageBucket: "emerals-b6b8a.firebasestorage.app",
  messagingSenderId: "375822389247",
  appId: "1:375822389247:web:24759998e6c80c363be1ca",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const functions = getFunctions(app);
const storage = getStorage(app);

export {
  db,
  auth,
  app,
  functions,
  storage,
  collection,
  addDoc,
  doc,
  updateDoc,
  deleteDoc,
  onSnapshot,
};
